<template lang="pug">
#laudos-renovabio
    #modal-renovabio
        template(slot='title')
            div.dialog-header
                | {{ $t('mensagens.laudos.elegibilidadeRenovabio') }}
        slot
        .modal-container-inner-filtros
        .filtro-tipo-consulta
            .title
                | {{ $t('mensagens.laudos.anoCertificacao') }}
                span.invalido &nbsp;*
            el-select.w-100(
                v-model='ano'
            )
                el-option(
                    v-for='ano in anos',
                    :key='ano',
                    :label='ano',
                    :value='ano'
                )
            .title.title-padding
                | {{ $t('mensagens.pessoas.nomeRazaoSocialProdutorBiomassa') }}
                span.invalido(v-if='!produtorBiomassaValido') &nbsp;*
            el-input.w-100(
                v-model='produtorBiomassa.nomeRazaoSocial',
                :placeholder="$t('mensagens.pessoas.nomeRazaoSocialProdutorBiomassa')"
            )
            .title.title-padding
                | {{ $t('mensagens.pessoas.numeroCpfCnpjProdutorBiomassa') }}
                span.invalido(v-if='!produtorBiomassaValido') &nbsp;*
                span.invalido(v-else-if='!documentoValido') &nbsp;Documento inválido

            .brasil
                el-input.w-100(
                    v-model='produtorBiomassa.cpfCnpj',
                    :placeholder="$t('mensagens.pessoas.numeroCpfCnpjProdutorBiomassa')",
                    v-mask='["###.###.###-##", "##.###.###/####-##"]'
                )
            .title.title-padding
                | {{ $t('mensagens.laudos.selecioneTipoDeInsumoParaCriacaoDeLaudo') }}
            el-radio-group.radio-group-container(
                v-model='tipoBusca',
                @change='onChangeHandle'
            )
                el-radio.radio-button(label='CAR') CAR
                el-radio.radio-button(label='TERRITORIO') {{ $t('mensagens.laudos.territorio') }}
            div.busca-territorio.none(id='idTerritorio')
                SelecionarTerritorio(
                    :tipoLaudo='tipoLaudo',
                    @getTerritoriosSelecionados='solicitarLaudos',
                    @cancelar-modal='changeShowModalSelecionarTerritorio',
                    ref='selecionarTerritorio'
                )
            div.busca-car(id='idCar')
                SelecionarCar(
                    :tipoLaudo='tipoLaudo',
                    :ano='ano',
                    :produtorBiomassa="produtorBiomassa",
                    @getLaudos='getLaudos',
                    @carJaCadastradosEncontrados="abrirModalCarsJaCadastrados",
                    @cancelar-modal='changeShowModalSelecionarTerritorio'
                )
</template>

<script>
import SelecionarTerritorio from '@/components/laudos/SelecionarTerritorio.vue';
import SelecionarCar from '@/components/laudos/SelecionarCar.vue';
import TipoLaudo from '@/constants/TipoLaudo';
import SelecionarLaudo from '@/components/laudos/SelecionarLaudo.vue';

import { mapGetters, mapState } from 'vuex';
import validators from '@/utils/validators';
import LaudosService from '@/services/LaudosService';

export default {
    name: 'LaudoRenovabioModal',
    components: {
        SelecionarLaudo,
        SelecionarTerritorio,
        SelecionarCar
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        ...mapState(['usuarioIsLaudo']),
        produtorBiomassaValido() {
            return this.validarProdutorBiomassa();
        },
        documentoValido() {
            return this.validarDocumento();
        }

    },
    watch: {
        produtorBiomassaValido: function (value) {
            this.produtorBiomassa.valido = value && this.validarDocumento();
        },
        documentoValido: function (value) {
            this.produtorBiomassa.valido = value && this.validarProdutorBiomassa();
        }
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.RENOVABIO,
            idLaudo: null,
            laudos: [],
            ano: null,
            produtorBiomassa: {
                nomeRazaoSocial: '',
                cpfCnpj: '',
                valido: true
            },
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                car: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.RENOVABIO
            },
            anos: [],
            rowInfo: null,
            totalLaudos: 0,
            usuariosBuffer: {},
            showModalInsercaoResultados: false,
            loading: false,
            isLaudoUnico: false,
            tipoBusca: 'CAR',
            showModalSelecionarTerritorios: false
        };
    },
    async mounted() {
        if (this.usuarioIsLaudo) {
            this.$router.push({ name: 'LaudoAvaliacaoSocioambiental' });
        }
        await this.getLaudos();

        LaudosService.listarAnoRenovabio().then(response => {
            this.anos = response.data;
        }).catch(() => {
            this.$notify.error({
                message: this.$t(
                    'mensagens.laudos.ocorreuUmErroAoBuscarAnoCertificacaoRenovabio'
                )
            });
        });
    },
    methods: {
        async getLaudos() {
            this.$emit('getLaudos');
        },

        abrirModalCarsJaCadastrados(
            quantidadeCARs,
            laudosInfo,
            carsJaCadastrados,
            confirmacaoAutomaticaLaudo
        ) {
            this.$emit('showModalCarJaCadastrados', quantidadeCARs, laudosInfo, carsJaCadastrados, confirmacaoAutomaticaLaudo);
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
            this.showBusca();
            this.$emit('showModalSelecionarTerritorios');
        },

        solicitarLaudos(idsTerritoriosSelecionados) {
            let idsTerritorio = '';
            idsTerritoriosSelecionados.forEach(territorio => {
                idsTerritorio += territorio.id + '-';
            });
            this.$router.push({
                name: 'LaudoSolicitacaoRenovabio',
                params: { idsTerritorio, produtorBiomassa: this.produtorBiomassa, ano: this.ano }
            });
        },

        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.getLaudos();
        },

        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.getLaudos();
        },

        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        },

        onChangeHandle() {
            this.showBusca();
        },

        showBusca() {
            if (this.tipoBusca === 'CAR') {
                $('#idTerritorio').addClass('none');
                $('#idCar').removeClass('none');
            } else {
                $('#idCar').addClass('none');
                $('#idTerritorio').removeClass('none');
            }
        },

        validarDocumento() {
            if (this.produtorBiomassa.cpfCnpj) return validators.validarDocumento(this.produtorBiomassa.cpfCnpj);

            return true;
        },

        validarProdutorBiomassa() {
            let temNome = this.produtorBiomassa.nomeRazaoSocial != null && this.produtorBiomassa.nomeRazaoSocial !== '';
            let temDocumento = this.produtorBiomassa.cpfCnpj != null && this.produtorBiomassa.cpfCnpj !== '';

            return (temNome && temDocumento) || (!temNome && !temDocumento);
        }
    }
};
</script>

<style scoped lang="scss">
#laudos-renovabio {
    #modal-renovabio {
        .dialog-header {
            background-color: #e9e9e9;
            color: #00413c;
            padding: 15px;
            margin: -20px -20px 20px -20px;
            font-size: 18px;
            font-weight: 600;
            border-radius: 5px, 5px, 0px, 0px;
            box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
        }
        
        .el-dialog__body {
            max-height: 525px !important;
            padding: 15px;
        }

        .filtro-tipo-consulta {
            color: #00413c;
        }

        .title-padding {
            padding: 15px 0px 5px 0px;
        }

        .invalido {
            color: var(--danger);
        }
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .laudo-margin {
        margin-bottom: 20px;
    }

    .selecionados,
    .nao-selecionados {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }

    .lista {
        background: var(--white);
        border-radius: 4px;
        overflow: hidden;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .radio-group-container {
        max-width: 250px;
        height: 20px;
        display: flex;
        flex-direction: column;
    }

    .radio-button {
        margin-right: 20px !important;
    }

    .busca-territorio {
        margin-top: 28px !important;
    }

    .busca-car {
        margin-top: 30px !important;
    }

    .none {
        display: none !important;
    }
}
</style>
